import Link from 'next/link';

import { ResourceListItem } from 'src/types/ResourceListItem';

import CardAttributeList from '../_CardAttributeList/_CardAttributeList';

import styles from './_ContentCard.module.css';

export type ContentCardProps = {
	item: ResourceListItem;
};

export default function ContentCard(props: ContentCardProps): JSX.Element {
	const currentSite = props?.item?.Url.startsWith('/');

	return (
		<div className={styles.card + ' rounded noExternalSiteIcon'}>
			{props.item.ImageUrl && <img src={props.item.ImageUrl} alt={props.item.Title} className={styles.image} />}

			<div className={styles.textWrapper + ' padX padYL'}>
				<Link href={props.item.Url}>
					<a target={currentSite ? '_self' : '_blank'} className={`${styles.title} link linkOffset linkHoverSecondary noExternalSiteIcon`}>
						<h4>{props.item.Title}</h4>
					</a>
				</Link>

				<p className={styles.body}>{props.item.Description}</p>

				<CardAttributeList item={props.item} />

				{props.item.ButtonText && (
					<Link href={props.item.Url}>
						<a target={currentSite ? '_self' : '_blank'} className="button blueDark">
							{props.item.ButtonText}
						</a>
					</Link>
				)}
			</div>
		</div>
	);
}
